module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin": "0px 20px 0px 20px"
    },
    attrs: {
      "slot": "formcontent"
    },
    slot: "formcontent"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "showLargeScreenOnly formTitleBlock"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm",
    style: ('padding-left: 0px !important; color: ' + _vm.titleColor)
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../assets/static/images/icons/invoice.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('attachments.invc_gen')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly formTitleBlock"
  }, [_c('h6', {
    staticClass: "content-block labelAccordionForm creationFormTitle",
    style: ({
      color: _vm.titleColor
    })
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../assets/static/images/icons/invoice.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('attachments.invc_gen')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-block italicMandatoryIndication"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.asterisk_obligation_label')) + "\n      ")])]), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": "Type de facture électronique",
      "hasDatePicker": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('label', [_vm._v("Veuillez sélectionner le type de la facture électronique "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "list": "list-format"
    },
    model: {
      value: (_vm.invoiceFormat),
      callback: function($$v) {
        _vm.invoiceFormat = $$v
      },
      expression: "invoiceFormat"
    }
  }), _vm._v(" "), _c('b-form-datalist', {
    attrs: {
      "id": "list-format",
      "options": _vm.sortFormatsList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": "Informations du document",
      "hasDatePicker": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": "Référence de la facture"
    },
    model: {
      value: (_vm.invoiceRef),
      callback: function($$v) {
        _vm.invoiceRef = $$v
      },
      expression: "invoiceRef"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "disablePastDates": "",
      "inputType": "date",
      "inputLabel": "Date d'exécution du paiement"
    },
    model: {
      value: (_vm.dateExec),
      callback: function($$v) {
        _vm.dateExec = $$v
      },
      expression: "dateExec"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.formsSubTitle.my_acc_info')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('select-bank-account', {
    attrs: {
      "value": _vm.sellerIBAN
    },
    model: {
      value: (_vm.sellerIBAN),
      callback: function($$v) {
        _vm.sellerIBAN = $$v
      },
      expression: "sellerIBAN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": "Informations de l'acheteur"
    }
  }, [(_vm.contactSearch) ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-contact-dropdown-label-input', {
    attrs: {
      "inputLabel": "Choisir un contact comme acheteur"
    },
    on: {
      "change-contact": function($event) {
        return _vm.selectBuyer($event)
      }
    },
    model: {
      value: (_vm.contactName),
      callback: function($$v) {
        _vm.contactName = $$v
      },
      expression: "contactName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": "Nom / Raison sociale"
    },
    model: {
      value: (_vm.buyerName),
      callback: function($$v) {
        _vm.buyerName = $$v
      },
      expression: "buyerName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": "E-mail"
    },
    model: {
      value: (_vm.buyerEmail),
      callback: function($$v) {
        _vm.buyerEmail = $$v
      },
      expression: "buyerEmail"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isCompanyContact) ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Siren"
    },
    model: {
      value: (_vm.buyerSiren),
      callback: function($$v) {
        _vm.buyerSiren = $$v
      },
      expression: "buyerSiren"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Numéro d'identification à la TVA"
    },
    model: {
      value: (_vm.buyerTva),
      callback: function($$v) {
        _vm.buyerTva = $$v
      },
      expression: "buyerTva"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Adresse"
    },
    model: {
      value: (_vm.buyerAddress),
      callback: function($$v) {
        _vm.buyerAddress = $$v
      },
      expression: "buyerAddress"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Code Postal"
    },
    model: {
      value: (_vm.buyerZip),
      callback: function($$v) {
        _vm.buyerZip = $$v
      },
      expression: "buyerZip"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Ville"
    },
    model: {
      value: (_vm.buyerCity),
      callback: function($$v) {
        _vm.buyerCity = $$v
      },
      expression: "buyerCity"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Pays"
    },
    model: {
      value: (_vm.buyerCountry),
      callback: function($$v) {
        _vm.buyerCountry = $$v
      },
      expression: "buyerCountry"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": "Informations sur l'achat"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "15px",
      "padding-bottom": "15px"
    }
  }, [_c('b-row', [_c('label', [_vm._v("Veuillez renseigner les produits facturés: "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('b-row', {
      key: index
    }, [_c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "4"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "isMandatory": "",
        "inputLabel": "Description"
      },
      model: {
        value: (product.Desc),
        callback: function($$v) {
          _vm.$set(product, "Desc", $$v)
        },
        expression: "product.Desc"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "3"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "isMandatory": "",
        "inputType": "number",
        "inputLabel": "Quantité"
      },
      model: {
        value: (product.Qte),
        callback: function($$v) {
          _vm.$set(product, "Qte", $$v)
        },
        expression: "product.Qte"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "3"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "isMandatory": "",
        "inputType": "number",
        "inputLabel": "Prix total (€)"
      },
      on: {
        "blur": function($event) {
          product.Amount = (Number(product.Amount)) ? Number(product.Amount).toFixed(2) : ''
        }
      },
      model: {
        value: (product.Amount),
        callback: function($$v) {
          _vm.$set(product, "Amount", $$v)
        },
        expression: "product.Amount"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "col-1 fa fa-times-circle text-danger",
      staticStyle: {
        "font-size": "25px",
        "margin-top": "30px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeProduct(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_c('f7-icon', {
    staticClass: "text-success",
    attrs: {
      "fa": "plus-circle",
      "size": "25px"
    }
  }), _vm._v(" "), _c('i', {
    staticStyle: {
      "color": "gray",
      "margin-left": "10px"
    }
  }, [_vm._v("Ajouter un produit")])], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputValue": _vm.calculatedAmountHT,
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": "Montant HT"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": "Montant TVA"
    },
    on: {
      "blur": function($event) {
        _vm.amountTVA = (Number(_vm.amountTVA)) ? Number(_vm.amountTVA).toFixed(2) : ''
      }
    },
    model: {
      value: (_vm.amountTVA),
      callback: function($$v) {
        _vm.amountTVA = $$v
      },
      expression: "amountTVA"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "inputValue": _vm.calculatedAmountTTC,
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": "Montant TTC"
    }
  })], 1)], 1)], 2)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "2",
      "offset-lg": "8"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.$parent.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-times-circle"
  }), _vm._v("\n        Annuler\n      ")])], 1), _vm._v(" "), _c('b-col', [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canGenerate
    },
    on: {
      "click": function($event) {
        return _vm.closeAndGenerateInvoice()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-file"
  }), _vm._v("\n        Générer\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bd6df77", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd6df77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attachments/DevisForm.vue
// module id = 2448
// module chunks = 2